$.fn.FilterItem = function(filters) {
  let item = this
  item.name = item.data('filter')

  item.clicked = function() {
    filters.select(item)
  }

  return function() {
    if (item.attr('aria-selected') == 'true') {
      filters.current = item.name
    }
    item.on('click', item.clicked)
    return item
  }()
}

$.fn.Filters = function() {
  let self = this
  self.items = []
  self.current = undefined
  self.el = {
    $items: self.find('.filters__item'),
    $set: $(self.data('filter-set')),
  }

  self.select = function(item) {
    /* Current filter */
    if (self.current == item.name) return
    self.current = item.name

    /* Add hash */
    window.location.hash = self.current

    /* Select filter */
    self.el.$items.attr('aria-selected', 'false')
    item.attr('aria-selected', 'true')

    /* Filter elements */
    let $visibleElements = self.el.$set.filter(':visible')
    if ($visibleElements.length) {
      $visibleElements.stop().fadeOut(250, function() {
        let selection = (item.data('filter') == 'all') ? self.el.$set : $(self.data('filter').replace('$1', item.data('filter')))
        selection.fadeIn(250)
      })
    } else {
      let selection = (item.data('filter') == 'all') ? self.el.$set : $(self.data('filter').replace('$1', item.data('filter')))
      selection.fadeIn(250)
    }
  }

  return function() {
    self.el.$items.each(function() {
      let item = $(this).FilterItem(self)
      self.items.push(item)
    })
    if (window.location.hash) {
      self.el.$items.filter('[data-filter="' + window.location.hash.replace('#', '') + '"]').click()
    }
    if ('history' in window) {
      $(window).on('popstate', function() {
        self.el.$items.filter('[data-filter="' + window.location.hash.replace('#', '') + '"]').click()
      })
    }
    return self
  }()
}

export default {
  init() {
    $('.filters').each(function() {
      $(this).Filters()
    })
  },
}
